import Vue from "vue";
import { mapState } from "vuex";

import actionBarComponent from "@/components/child/actionBar/actionBar.vue";
import comboComponent from "@/components/child/form/combo.vue";
import { Component } from "@/decorators";
import JanelaColetaModel from "@/models/janelaColetaModel";
import UsuarioModel from "@/models/usuarioModel";
import janelaColetaService from "@/services/janelaColetaService";
import localEntregaService from "@/services/transporte/localEntregaService";
import { AppState } from "@/store/store";
import { applyTimeZoneDifference } from "@/utils/common/date";

import "../crud.scss";

@Component({
    components: {
        actionBarComponent,
        comboComponent,
    },
    computed: {
        ...mapState({
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
    },
})
export default class JanelaColetaEditComponent extends Vue {
    usuarioLogado: UsuarioModel;

    private service = janelaColetaService;

    models: JanelaColetaModel[] = [];
    locaisEntregaOptions: any[] = [];

    private async load() {
        this.models = [new JanelaColetaModel()];
        try {
            const data = await this.service.getByFranquia().withLoading().resolveWithJSON<JanelaColetaModel[]>();
            if (data.length > 0) {
                this.models = data.map(p => {
                    const model = new JanelaColetaModel();
                    model.updateFrom(p);

                    const date = applyTimeZoneDifference(new Date(p.horarioLimite), true);
                    model.horarioLimiteString = `${this.padLeft(date.getHours())}:${this.padLeft(date.getMinutes())}`;

                    return model;
                });
            }
        } catch {}
    }

    private padLeft(value: number) {
        const valueString = value.toString();
        return valueString.length == 1 ? "0" + valueString : valueString;
    }

    private async loadLocaisEntrega() {
        try {
            this.locaisEntregaOptions = await localEntregaService.comboCached(this.usuarioLogado.franquiaId);
        } catch {}
    }

    private async save() {
        try {
            const isValid = await this.$validator.validateAll();
            if (isValid) {
                this.models = this.models.map(p => {
                    const model = new JanelaColetaModel();
                    model.updateFrom(p);

                    model.horarioLimite = new Date();
                    model.horarioLimite.setHours(Number(model.horarioLimiteString.split(":")[0]));
                    model.horarioLimite.setMinutes(Number(model.horarioLimiteString.split(":")[1]));
                    model.horarioLimite = applyTimeZoneDifference(model.horarioLimite, false);

                    return model;
                });

                const sucesso = await this.service.updateModels(this.models).withLoading().resolveWithoutJSON();
                if (sucesso) {
                    await this.$showSuccess(this.$t("__.ts.sucesso"), this.$t("__.ts.janelaColetaAtualizada"));
                    this.$router.back();
                }
            } else {
                this.$focusErrorField();
            }
        } catch {}
    }

    private cancel() {
        this.$router.back();
    }

    private onAdd() {
        this.models.push(new JanelaColetaModel());
    }

    private onRemove(model: JanelaColetaModel) {
        this.models = this.models.filter(p => p != model);
    }

    private async mounted() {
        await this.loadLocaisEntrega();
        await this.load();
    }
}
